import Rest from '../rest'

/******************************************************************************
 *  Open Search
 *****************************************************************************/

/**
 * @type {OpenSearch}
 */
export default class OpenSearch extends Rest {

    constructor () {
        super('/search')
    }

    /**
     * Realiza uma busca via open search de acordo com um termo de busca
     *
     * @param {String|Integer} query Parâmetro a ser buscado via open search
     * @returns
     */
    search(query, instance, abortToken = null) {
        return this.http2.get(
            this.constructor.normalize(this.resource, instance),
            {
                params: {
                    q: query
                },

				cancelToken: abortToken,
            }
        )
    }

    searchReserves(query, instance, abortToken = null) {
        return this.http2.get(
            this.constructor.normalize(this.resource, instance),
            {
                params: {
                    q: query
                },
				cancelToken: abortToken
            }
        )
    }
}